import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import OfferSettings from "../../Helpers/Modals/OfferSettings";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainContent from "./MainContent";

function OpenForBids() {
  const [drawer, setDrawer] = useToggle(false);
  const [value, setValue] = useToggle(false);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <MainContent modalAction={setValue.toggle}>
        <OfferSettings action={setValue.toggle} value={value} />
      </MainContent>
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default OpenForBids;
